import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TypeTableHead } from "../../type/componentsType/TkTable";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "区分",
    keyword: "invoiceClass",
    type: "text",
  },
  {
    title: "請求先",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "金額",
    keyword: "invoiceAmt",
    type: "text",
  },
  {
    title: "請求日",
    keyword: "billingDate",
    type: "text",
  },
];

const headList: TypeTableHead[] = [
  { headTitle: "帳票名", align: "left" },
  { headTitle: "発議文章番号", align: "left" },
  { headTitle: "発行日", align: "left" },
];

export { fakeTableList, headList };
